import { css } from '@emotion/core';
import theme from '../../themes/default';
import styleUtils from '../../styles/utils';

const container = css`
  ${styleUtils.flex.container({
    direction: 'column',
    justifyContent: 'space-between',
  })};
  padding: ${theme.spacing.small} 0;
  width: 64px;
  background: linear-gradient(180deg, #5a33ce 0%, #6929c4 100%);
`;

const decorations = css`
  ${styleUtils.flex.container({ direction: 'column' })};
`;

export default {
  container,
  decorations,
};
